export default class KeyGenerator {
    public generate(length: number = 10): string {
        return [...Array(length)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
    }

    public static generate(length: number = 10): string {
        return [...Array(length)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
    }
}